import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { getPicklist } from '../actions';

class OtherHouseHoldMember extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    shouldComponentUpdate() {
        return true;
    }

    render() {
        const {
            form, errorMessage, onInputChanged, index,
            objectInfo,
        } = this.props;
        const mainApplicant = this.props.mainApplicant || form.mainApplicant;
        return (
            <div className="row">
                <div className="row">
                    {/*
                        <pre>{JSON.stringify(form, null, 4)}</pre>
                    */}
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Full Name <small className="red">(required)</small></label>
                            <input
                                onChange={onInputChanged}
                                name={`Full_Name__c.${index}`}
                                type="text"
                                className={`form-control ${errorMessage.Full_Name__c ? 'need-fix' : ''}`}
                                placeholder="Fullname"
                                value={form.Full_Name__c}
                                disabled={form.mainApplicant}
                            />
                            <p className="error-message">{errorMessage.Full_Name__c}</p>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>ID Type <small className="red">(required)</small></label>
                            <select
                                onChange={onInputChanged}
                                name={`ID_Type__c.${index}`}
                                className={`form-control ${errorMessage.ID_Type__c ? 'need-fix' : ''}`}
                                placeholder="ID Type"
                                value={form.ID_Type__c}
                                disabled={form.mainApplicant}
                            >
                                <option value="" />
                                {getPicklist('ID_Type__c', objectInfo.Person__c)}
                            </select>
                            <p className="error-message">{errorMessage.ID_Type__c}</p>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>NRIC <small className="red">(required)</small></label>
                            <input
                                onChange={onInputChanged}
                                name={`ID_Number__c.${index}`}
                                type="text"
                                className={`form-control ${errorMessage.ID_Number__c ? 'need-fix' : ''}`}
                                placeholder="NRIC"
                                value={form.ID_Number__c}
                                disabled={form.mainApplicant}
                            />
                            <p className="error-message">{errorMessage.ID_Number__c}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4">
                        <label>Date Of Birth <small className="red">(required)</small></label>
                        <DatePicker
                            name={`Date_of_Birth__c.${index}`}
                            selected={form.Date_of_Birth__c ? moment(form.Date_of_Birth__c) : null}
                            dateFormat="DD/MM/YYYY"
                            onChange={val => onInputChanged(val, 'Date_of_Birth__c', index)}
                            placeholderText="Date of Birth"
                            className={`form-control ${errorMessage.Date_of_Birth__c ? 'need-fix' : ''}`}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            disabled={form.mainApplicant}
                            maxDate={moment()}
                        />
                        <p className="error-message">{errorMessage.Date_of_Birth__c}</p>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Nationality <small className="red">(required)</small></label>
                            <select
                                name={`Nationality__c.${index}`}
                                onChange={onInputChanged}
                                value={form.Nationality__c}
                                className={`form-control valid select ${errorMessage.Nationality__c ? 'need-fix' : ''}`}
                                required
                                disabled={mainApplicant}
                            >
                                <option value="" />
                                {getPicklist('Nationality__c', objectInfo.Person__c)}
                            </select>
                            <p className="error-message">{errorMessage.Nationality__c}</p>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Other Nationality</label>
                            <input
                                name={`Other_Nationality__c.${index}`}
                                type="text"
                                className={`form-control valid select ${errorMessage.Other_Nationality__c ? 'need-fix' : ''}`}
                                value={form.Other_Nationality__c || ''}
                                onChange={onInputChanged}
                                disabled={form.Nationality__c !== 'Others' || mainApplicant}
                            />
                            <p className="error-message">{errorMessage.Other_Nationality__c}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OtherHouseHoldMember.propTypes = {
    form: PropTypes.object.isRequired,
    mainApplicant: PropTypes.bool,
    onInputChanged: PropTypes.func.isRequired,
    errorMessage: PropTypes.object.isRequired,
    objectInfo: PropTypes.object.isRequired,
    index: PropTypes.number,
};

OtherHouseHoldMember.defaultProps = {
    index: 0,
    mainApplicant: false,
};
const mapDispatchToProps = dispatch => (
    bindActionCreators({}, dispatch)
);

const mapStateToProps = state => ({
    schoolList: state.salesforce.schoolList.fields,
});


export default connect(mapStateToProps, mapDispatchToProps)(OtherHouseHoldMember);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/Tab4/OtherHouseholdMember01.js
// module id = 1017
// module chunks = 0